import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import {
  type PurchaseOrderCommentInput,
  type PurchaseOrderCommentValues,
  purchaseOrderCommentSchema,
} from '@/features/purchase-order/schema/purchase-order-comment-schema';
import type { PurchaseOrderComment } from '@/types/core/purchase-order/purchase-order-comment';

type PurchaseOrderMainCommentFormDefaults = Pick<
  PurchaseOrderComment,
  'id' | 'value'
>;

export function usePurchaseOrderMainCommentForm(
  comment: PurchaseOrderMainCommentFormDefaults,
) {
  const form = useForm<
    PurchaseOrderCommentInput,
    unknown,
    PurchaseOrderCommentValues
  >({
    mode: 'onChange',
    defaultValues: comment,
    resolver: zodResolver(purchaseOrderCommentSchema),
  });

  return form;
}
